import { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Menu,
  MenuButton,
  Button,
  MenuList,
  Checkbox,
  MenuItem,
  HStack,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import toast from "react-hot-toast";
import { useSession } from "next-auth/react";
import moment from "moment";
import { getAccount } from "utils/sessionHelper";
import { searchPeople } from "controllers/list";
import { getFormattedContacts } from "./utils";
import { textStyle } from "theme/names";

export function PublicInteraction({ addPeople }) {
  const [interactionInterval, setInteractionInterval] = useState<number>(7);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [like, setLike] = useState<boolean>(false);
  const [reply, setReply] = useState<boolean>(false);
  const [retweet, setRetweet] = useState<boolean>(false);
  const { data: session } = useSession() ?? {}

  const handleImport = async () => {
    if (!like && !reply && !retweet) {
      toast.error("Please select atleast 1 interaction");
      return;
    }

    setIsLoading(true);
    const since = new Date(
      // @ts-ignore
      moment().subtract(interactionInterval, "day").startOf("day")
    ).getTime();

    let actions: string[] = [];
    if (like) actions.push("like");
    if (reply) actions.push("reply");
    if (retweet) actions.push("retweet");

    const dataToSend: any = {
      idUser: getAccount(session)?.id,
      thWriteAccessToken: getAccount(session)?.thWriteAccessToken,
      thWriteSecretToken: getAccount(session)?.thWriteSecretToken,
      thApp: getAccount(session)?.thApp,
      from: "interaction",
      actions: actions.join(","),
      since,
    };

    const data = await searchPeople(session, dataToSend);
    setIsLoading(false);

    if (data?.success === 0) {
      toast.error(data.error);
      return;
    }

    if (data.contacts.length === 0) {
      toast.success(
        `No ${actions.join(",")} found from last ${interactionInterval}`
      );
      return;
    }

    const formattedList = getFormattedContacts(data.contacts);

    setLike(false);
    setReply(false);
    setRetweet(false);
    setInteractionInterval(7);

    addPeople(formattedList);
  };

  return (
    <Box>
      <Flex alignItems="center">
        <Text textStyle={textStyle["body.medium.light"]}  fontWeight="medium">
          Has interacted with one of my posts in the last
        </Text>
        <Menu>
          <MenuButton
            as={Button}
            size="sm"
            variant="outline"
            rightIcon={<ChevronDownIcon />}
            ml="2"
            isDisabled={isLoading}
          >
            {interactionInterval} days
          </MenuButton>
          <MenuList maxH="215px" overflow="scroll">
            {[7, 14, 30].map((x) => (
              <MenuItem
                key={x}
                onClick={() => {
                  setInteractionInterval(x);
                }}
              >
                {x} days
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        <Button onClick={handleImport} size="sm" ml="4" isLoading={isLoading}>
          Import
        </Button>
      </Flex>

      <HStack ml="2" mt="2" spacing="4">
        <Checkbox
          fontWeight="medium"
          size="sm"
          isChecked={like}
          onChange={(e) => {
            setLike(!like);
          }}
        >
          Likes
        </Checkbox>
        <Checkbox
          fontWeight="medium"
          size="sm"
          isChecked={reply}
          onChange={(e) => {
            setReply(!reply);
          }}
        >
          Replies
        </Checkbox>
        <Checkbox
          fontWeight="medium"
          size="sm"
          isChecked={retweet}
          onChange={(e) => {
            setRetweet(!retweet);
          }}
        >
          Retweets
        </Checkbox>
      </HStack>
    </Box>
  );
}
